import { useTranslation } from "react-i18next";

import type { MapState } from "@map/mapiq-map/MapState";
import type { MarkerData } from "@map/mapiq-map/markers/NodeMarkerData";
import { trackError } from "@lib/infrastructure";
import { MapiqMap } from "@molecules";

type HaNMapPreviewProps = {
  buildingId: string;
  floorId: string;
  nodeId: string;
  markerData?: MarkerData[];
};

// Shows where a room or area is on its floor, opened on it and without interaction. On phones the details cover the
// page's map, so they show this instead.
export const HaNMapPreview = ({ buildingId, floorId, nodeId, markerData }: HaNMapPreviewProps) => {
  const { t } = useTranslation();
  const mapState: MapState = { buildingNodeStates: new Map([[nodeId, "selected"]]) };

  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-[20px] font-semibold leading-[25px]">{t("translation:LocationTitle")}</h3>

      <div className="relative h-[200px] overflow-hidden rounded-lg bg-beige-100">
        <MapiqMap
          buildingId={buildingId}
          floorId={floorId}
          type="preference"
          interactive={false}
          mapState={mapState}
          markerData={markerData}
          defaultNodeIdsInView={[nodeId]}
          onError={error => trackError(error, { area: "HereAndNow_MapPreview" })}
        />
      </div>
    </section>
  );
};
